// extracted by mini-css-extract-plugin
export default {"label":"aKNpMa","sidePlace":"bKNpMa","inputPlace":"cKNpMa"};